import * as ugcDashbord from '../services';

export default {
  namespace: 'ugcDashbord',

  state: {
    chart1Data: {},
    chart2Data: {},
    chart3Data: {},
    chart4Data: null,
    chart5Data: {},
    chart6Data: {},
    chart7Data: [],
    chart8Data: {},
    chart9Data: {},
    chart10Data: {},
    dictData: [],
  },

  effects: {
    //基础信息
    *getStatistics({ payload: { values } }, { call, put }) {
      const response = yield call(ugcDashbord.getStatistics, values);
      // if (!response.errCode) {
      //   if (callback && typeof callback === 'function') {
      //     callback(response.data);
      //   }
      // }
      yield put({
        type: 'save',
        payload: {
          chart1Data: response?.data || {},
        },
      });
    },
    //订单金额趋
    *getOrder({ payload: { values } }, { call, put }) {
      const response = yield call(ugcDashbord.getOrder, values);
      yield put({
        type: 'save',
        payload: {
          chart2Data: response?.data || {},
        },
      });
    },
    //型动值变化趋势
    *queryTrendActionValueChangesReport({ payload: { values } }, { call, put }) {
      const response = yield call(ugcDashbord.queryTrendActionValueChangesReport, values);
      yield put({
        type: 'save',
        payload: {
          chart9Data: response?.data || {},
        },
      });
    },
    //查询新会员购买报表
    *queryNewMemberBuyReport({ payload: { values } }, { call, put }) {
      const response = yield call(ugcDashbord.queryNewMemberBuyReport, values);
      yield put({
        type: 'save',
        payload: {
          chart10Data: response?.data || {},
        },
      });
    },
    // 积分增长、消耗趋势
    *getPoint({ payload: { values } }, { call, put }) {
      const response = yield call(ugcDashbord.getPoint, values);
      yield put({
        type: 'save',
        payload: {
          chart3Data: response?.data || {},
        },
      });
    },
    // 年龄分布
    *getAge({ payload: { values } }, { call, put }) {
      const response = yield call(ugcDashbord.getAge, values);
      yield put({
        type: 'save',
        payload: {
          // chart4Data: response?.data || {},
          chart4Data: response ? response : {},
        },
      });
    },
    // 来源分布
    *getSource({ payload: { values } }, { call, put }) {
      const response = yield call(ugcDashbord.getSource, values);
      yield put({
        type: 'save',
        payload: {
          chart5Data: response?.data || {},
        },
      });
    },
    // 地域分布
    *getActiveUser({ payload: { values } }, { call, put }) {
      const response = yield call(ugcDashbord.getActiveUser, values);
      yield put({
        type: 'save',
        payload: {
          chart6Data: response?.data || {},
        },
      });
    },
    // 等级分布
    *getGrade({ payload: { values } }, { call, put }) {
      const response = yield call(ugcDashbord.getGrade, values);
      // console.log(response, 'response');
      if (response?.code === 0) {
        yield put({
          type: 'save',
          payload: {
            chart7Data: response?.data || [],
          },
        });
      }
    },
    // 会员变化趋势
    *getCount({ payload: { values } }, { call, put }) {
      const response = yield call(ugcDashbord.getCount, values);
      if (response?.code === 0) {
        yield put({
          type: 'save',
          payload: {
            chart8Data: response?.data || {},
          },
        });
      }
    },
    // 获取字典数据
    *getDict({ payload: {}, callback }, { call, put }) {
      const response = yield call(ugcDashbord.getDict);
      if (callback && typeof callback === 'function') {
        return callback(response.data);
      }
      yield put({
        type: 'save',
        payload: {
          dictData: response ? response.data : [],
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
